module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_szerzkot3.0a79490c.jpg";